import React from 'react';

import { IconComponentFunction, IconComponentProps, IconText, InfoIcon, TickCircleIcon, WarningIcon } from '@motorway/mw-highway-code';

import { useBreakpoint } from '../../../../../../components/misc/Breakpoints/Breakpoints';
import { FiguresBoxHeaderIconType, FiguresBoxHeaderProps } from '../FiguresBox.types';

import styles from './FiguresBoxHeader.scss';

const headerIcon: Record<FiguresBoxHeaderIconType, (props: IconComponentProps) => React.ReactElement> = {
  error: WarningIcon,
  info: InfoIcon,
  success: TickCircleIcon,
};

const FiguresBoxHeader = ({
  icon,
  subtitle,
  title,
}: FiguresBoxHeaderProps) => {
  const breakpoints = useBreakpoint();
  const mobileBreakpoint = breakpoints.maxWidth.breakpointMobile;

  const TitleElement = () => (<p className={styles.title}>{title}</p>);
  const DescElement = () => (subtitle ? <span className={styles.desc}>{subtitle}</span> : null);

  if (!icon) {
    return (
      <div className={styles.figuresBoxHeader}>
        <TitleElement />
        <DescElement />
      </div>
    );
  }

  return (
    <div className={styles.figuresBoxHeader}>
      <IconText
        alignIcon={mobileBreakpoint ? 'top' : 'left'}
        data-thc-icontext={icon}
        icon={headerIcon[icon] as IconComponentFunction}
        text={title}
        variant='small--heading6'
      />
      <DescElement />
    </div>
  );
};

export { FiguresBoxHeader };
